export default "/images/press4.png?aa19ea8f80572df4443f2ae550829760";